const systemSettingsTranslationsAR = {
  socialLinksSectionHeader: 'روابط مواقع التواصل',
  vatTaxInputLabel: 'الضريبة',
  taxSectionHeader: 'قيمة الضريبة المضافة',
  twitterInputLabel: 'Twitter',
  facebookInputLabel: 'Facebook',
  youtubeInputLabel: 'Youtube',
  linkedinInputLabel: 'Linkedin',
  tiktokInputLabel: 'TikTok',
  instagramInputLabel: 'Instagram',
  accountNumberInputLabel: 'رقم الحساب',
  beneficiaryNameInputLabel: 'اسم المستفيد',
  swiftCodeInputLabel: 'رمز سويفت',
  wireTransferSettings: 'إعدادات التحويل البنكي',
  discountSettings: 'نسبة الخصم للمقاطع السريعة',
  from1To4Videos: 'من 1 إلى 4 مقاطع',
  from5To9Videos: 'من 5 إلى 9 مقاطع',
  from10To14Videos: 'من 10 إلى 14 مقاطع',
  from15AndAboveVideos: '15 مقطع فأكثر',
};

export default systemSettingsTranslationsAR;
